import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { PaymentDialogComponent, PaymentDialogData } from '../components/payment-dialog/payment-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalPaymentService {
  constructor(
    private dialog: MatDialog,
    private sheet: MatBottomSheet,
    private bp: BreakpointObserver
  ) {}

  open(data: PaymentDialogData): Observable< undefined | number> {
    const isHandset = this.bp.isMatched(Breakpoints.Handset);

    const ref:
      | MatDialogRef<PaymentDialogComponent, number>
      | MatBottomSheetRef<PaymentDialogComponent, number> = isHandset
      ? this.sheet.open(PaymentDialogComponent, { data })
      : this.dialog.open(PaymentDialogComponent, { data });

    return 'afterClosed' in ref ? ref.afterClosed() : ref.afterDismissed();
  }
}
